export enum RewardRuleEffects {
    AddDiscount = "AddDiscount",
    AddPoints = "AddPoints",
    AddFreeItem = "AddFreeItem",
    CanApplyNonExpiredReward = "CanApplyNonExpiredReward",
    CanApplyLiveReward = "CanApplyLiveReward",
}